import { List } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ScheduleListRow } from "./schedule-list-row"
import { compareByCode } from "authoring/lib/compare-by-code"

export function ApprovedSchedulesList({ schedules = [], ...props }) {
    const sortedSchedules = [...schedules].sort(compareByCode)

    return (
        <List
            data-cy="approved-schedules-list"
            disablePadding
            {...props}
            sx={{
                maxHeight: "32vh",
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                overflowY: "auto",
                overflowX: "hidden",
                overscrollBehavior: "contain",
                ...props.sx,
            }}
        >
            <Repeat
                list={sortedSchedules}
                item={<ScheduleListRow showPublishedInfo data-cy="approved-schedule-row" />}
                pass="schedule"
            />
        </List>
    )
}
